import React from 'react';
import { useTranslation } from 'react-i18next';

import { Switch } from '@blueprintjs/core';
import { parseBool } from '@hogwarts/validation';

const SwitchBox = ({
  fieldHelpers,
  large,
  formField,
  fieldMeta,
  readOnly,
  label,
}) => {
  const { t } = useTranslation();
  const value = parseBool(formField.value);
  if (fieldMeta.error) {
    // show this in red?
  }
  return (
    <Switch
      style={{
        marginBottom: 0,
      }}
      disabled={readOnly}
      checked={!!value}
      large={large == null ? true : large}
      onChange={(args) => {
        const checked = args.target.checked;
        fieldHelpers.setTouched(true, false);
        fieldHelpers.setValue(checked);
      }}
      label={t(label)}
    />
  );
};

export default {
  name: 'Switch',
  options: [],
  decorators: {
    label: false,
  },
  Component: SwitchBox,
};
